module.exports = __webpack_public_path__ + "static/dmon-004-3881c64710aa39f9a250364fb2e08977.jpg";